import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { type ReponseErrorPopupModel } from "./reponseErrorPopupModel.interface";
import { HttpError } from "./httpError.interface";

@Injectable()
export class ResponseErrorHandlerService {
    timersValue = {
        successfullySaved: 3 * 1000,
        cannotSaveChanges: 10 * 1000,
        CancelSaved: 5 * 1000,
        Default: 5 * 1000,
        deviceTrusted: 3 * 1000,
    };

    showPopupEmitter = new Subject<ReponseErrorPopupModel>();
    showPopupEvent$ = this.showPopupEmitter.asObservable();
    showBannerEmitter = new Subject<{ type: string; error?: string }>();
    showBannerEvent$ = this.showBannerEmitter.asObservable();
    hideBannerEmitter = new Subject<{ type: string }>();
    hideBannerEvent$ = this.hideBannerEmitter.asObservable();

    constructor() {}

    showPopup(params) {
        if (params.typeLayout) {
            this.showPopupEmitter.next({
                isShowed: true,
                typeLayout: params.typeLayout,
                messageCode: params.messageCode,
                additionInfo: params.additionInfo,
            });
        }
    }

    hidePopup(messageCode: string = null) {
        this.showPopupEmitter.next({
            isShowed: false,
            typeLayout: null,
            messageCode: messageCode,
            additionInfo: null,
        });
    }

    responseErrorHandler(error: HttpError | any, additionFlag?: any) {
        const params = {
            typeLayout: "ERROR",
        };
        if (error && error.status !== undefined) {
            switch (error.status) {
                case 409:
                    if (error.error && error.error.Message === "Unique field Email is already in table.") {
                        params["messageCode"] = "409ErrorUniqueEmail";

                        this.showPopup(params);
                        break;
                    }
                    params["messageCode"] = "defaultError";
                    this.showPopup(params);
                    break;
                case 429:
                    if (error.error && error.error.Message === "Too Many Requests") {
                        params["messageCode"] = "429TooManyRequests";
                        this.showPopup(params);
                        break;
                    }
                    params["messageCode"] = "defaultError";
                    this.showPopup(params);
                    break;
                case 500:
                    params["messageCode"] = "500Error";
                    this.showPopup(params);
                    break;

                default:
                    params["messageCode"] = "defaultError";
                    this.showPopup(params);
            }
            console.warn(JSON.stringify(error));
        } else {
            params["messageCode"] = "defaultError";
            this.showPopup(params);
        }
    }

    showBanner(data) {
        this.showBannerEmitter.next(data);
    }
}
